import { request, METHOD } from '../utils/request.js'

// 查看是否有准考证
export function checkOrder(data) {
  return request(
    '/h5Mfitness/parent/checkOrder',
    METHOD.POST,
    data
  )
}
// 获得家庭作业列表

export function getHomeworkInfoList(data) {
    return request(
      '/h5Mfitness/parent/getHomeworkInfoList',
      METHOD.POST,
      data
    )
  }

 
    // 家庭作业详情
export function getHomeworkByHomeId(data) {
  return request(
    '/h5Mfitness/parent/getHomeworkByHomeId',
    METHOD.POST,
    data
  )
}
  // 获得学生完成优良率 次数
export function getFractionByHomework(data) {
    return request(
      '/h5Mfitness/parent/getFractionByHomework',
      METHOD.POST,
      data
    )
  }
    // 家庭作业详情列表
export function getFractionByFractionStatus(data) {
    return request(
      '/h5Mfitness/parent/getFractionByFractionStatus',
      METHOD.POST,
      data
    )
  }
      // 提交
export function submitHomework(data) {
    return request(
      '/h5Mfitness/parent/submitHomework',
      METHOD.POST,
      data
    )
  }
  